export const ShippingCarrierValues = ["ups", "fedex", "usps"];
export const ShippingCarrierDomainByCarrier = {
    ups: "ups.com",
    fedex: "fedex.com",
    usps: "usps.com",
};
export function isHost(hostname, exactOrSuffix) {
    return hostname === exactOrSuffix || hostname.endsWith(`.${exactOrSuffix}`);
}
export function detectShippingCarrierFromHostname(hostname) {
    const normalizedHostname = hostname.toLowerCase();
    if (isHost(normalizedHostname, ShippingCarrierDomainByCarrier.ups))
        return "ups";
    if (isHost(normalizedHostname, ShippingCarrierDomainByCarrier.fedex))
        return "fedex";
    if (isHost(normalizedHostname, ShippingCarrierDomainByCarrier.usps))
        return "usps";
    return undefined;
}
export function detectShippingCarrierFromUrl(url) {
    if (!url)
        return undefined;
    try {
        const hostname = new URL(url).hostname.toLowerCase();
        return detectShippingCarrierFromHostname(hostname);
    }
    catch {
        return undefined;
    }
}
export function isShippingCarrier(value) {
    if (!value)
        return false;
    return ShippingCarrierValues.includes(value);
}
